import {EntityService} from '../../../service/EntityService';

export class EmailTemplateService extends EntityService {

  static entity = 'app/email-template';

}
